(function(Way2web) {
    'use strict';

    Way2web.handlers = {};
    Way2web.log = [];

    Way2web.onDomReady = function() {
        Way2web.handler();
        Way2web.Modal.gallery();
    };

    /**
     * Call functions on the page that are set in the handlers data attribute.
     * Handler example:
     * Way2web.handlers.test = Test.init;
     * You can add this handler in the Test element.
     * In the HTML this can be triggert by:
     * <body data-handlers="test">
     * You can add multiple handlers, seperated by a space.
     */
    Way2web.handler = function() {
        var handlers = $('body').data('handlers');
        var elements = [];
        var element;
        var item;
        var action;

        if (handlers) {
            elements = handlers.split(/\s+/);
            for (item in elements) {
                element = elements[item];
                action = Way2web.handlers[element];
                if (action) {
                    action.call(element);
                    Way2web.log.push(element);
                }
            }
        }
    };
})(window.Way2web = window.Way2web || {});

$(document).ready(Way2web.onDomReady);
